module.exports = __webpack_public_path__ + "img/mon.ac3d19e5.svg";